<template>
    <div class="default-body customer-qw-wrap">
        <div class="user-info-qw" style="padding: 3px">
            <el-scrollbar :style="{height: containerHeight+'px'}">
                <div style="display: flex;margin-bottom: 5px">
                    <el-input
                        size="mini"
                        v-model="formParam.orderNumber"
                        placeholder="输入订单号">
                    </el-input>
                    <el-button type="primary" size="mini" style="margin-left: 5px" @click="initOrderList">查询</el-button>
                </div>
                <div style="display: flex;">
                    <el-button size="mini" plain type="success" style="margin-right: 5px" @click="addOrder">新增</el-button>
                    <el-tooltip class="item" effect="dark" placement="bottom">
                        <div style="width: 150px" slot="content">{{orderLink}}</div>
                        <el-button type="danger" plain size="mini" @click="copyText(orderLink)">复制订单链接</el-button>
                    </el-tooltip>
                </div>

                <el-empty v-if="orderList.length<=0" :image-size="200"></el-empty>

                <el-descriptions v-for="(item,index) in orderList" :labelStyle="{width:'50px'}" style="margin-top: 5px" class="margin-top" :column="1" size="mini" border>
                    <el-descriptions-item label="ERP单号">
                        <el-input v-model="item.orderNumber" size="mini" placeholder="请输入erp订单号"/>
                    </el-descriptions-item>
                    <el-descriptions-item label="用户信息">
                        <div style="font-style: italic">
<!--                            <i style="color: #2dacd1" class="el-icon-s-custom"></i>-->
                            昵称:{{item.nickName}}
                        </div>
                        <div style="font-style: italic">
<!--                            <i style="color: #2dacd1" class="el-icon-user-solid"></i>-->
                            BD:{{item.userName}}
                        </div>
                        <div style="font-style: italic">
<!--                           <i style="color: #2dacd1" class="el-icon-s-promotion"></i>-->
                            备注:
                        </div>
                        <el-input v-model="item.userRemark" size="mini" placeholder="请输入用户备注"/>
                    </el-descriptions-item>
                    <el-descriptions-item label="订单信息">
                        <div style="font-style: italic">
<!--                            <i style="color: #55a532" class="el-icon-s-order"></i>-->
                            物流单号:{{item.trackingNumber}}
                        </div>
                        <div style="font-style: italic">
<!--                            <i style="color: #55a532" class="el-icon-date"></i>-->
                            更新时间:{{item.updateTime||item.createTime}}
                        </div>
                        <div style="font-style: italic">
<!--                            <i style="color: #55a532" class="el-icon-s-promotion"></i>-->
                            备注:
                        </div>
                        <el-input v-model="item.orderRemark" size="mini" placeholder="请输入订单备注"/>

                    </el-descriptions-item>
                    <el-descriptions-item label="操作">
                        <el-tag size="mini" effect="plain" type="success" style="margin-right: 5px;cursor: pointer" @click="saveRecord(item)">保存</el-tag>
                        <el-popconfirm
                            title="确定要删除这条数据吗？"
                            @confirm="deleteRecord(item,index)"
                        >
                            <el-tag slot="reference" style="cursor: pointer" size="mini" effect="plain" type="danger">删除</el-tag>

                        </el-popconfirm>
                    </el-descriptions-item>

                </el-descriptions>
            </el-scrollbar>
        </div>
    </div>

</template>
<script>
import {wxQw} from "@/api/wxQwConfig";

let wx = window.wx
let qwPlatform = navigator.userAgent.indexOf('wxwork')>-1?true:false

export default {
    data() {
        return {
            qwPlatform,
            formParam: {
                orderNumber: '',
                customerId: this.$route.query.customerId|| '',
                pageSize: 20,
                currentPage: 1,
            },
            orderLink:'',
            orderList:[],
            containerHeight:'900px',
        }
    },
    created() {
        // this.initHeight()
    },
    mounted(){
        this.initHeight()
        // console.log("item1",wx.getSystemInfo());
        //企微打开:config
        if(qwPlatform){
            wxQw().then(()=>{
                if(this.formParam.customerId != ''){
                    this.initOrderList();
                }else{
                    wx.invoke('getCurExternalContact', {}, (res)=>{
                        if (res.err_msg == 'getCurExternalContact:ok') {
                            let userInfo = res;
                            console.log('userInfo',userInfo)
                            this.formParam.customerId = userInfo.userId;
                            this.initOrderList();
                        } else {
                            this.formParam.customerId="";
                        }
                    })
                }
            })
        }else{
            console.log(121212)
            this.initOrderList();
        }
        window.onresize  = () => {
            this.initHeight()
        }
    },
    beforeDestroy() {
    },
    methods: {
        initHeight(){
            console.log(document.querySelector('.default-body').offsetHeight);
            this.containerHeight = document.querySelector('.default-body').offsetHeight-60
        },
        initOrderList(){
            this.$apiGet('lechun-cms/scrmOrder/getList', { ...this.formParam}).then(res => {
                console.log(res)
                this.orderList = res.pageInfo.list;
                this.orderLink='https://csms.lechun.cc/scrmOrderUser?userid=' + res.userId + '&customerId=' + this.formParam.customerId

            })
        },
        addOrder(){
            this.orderList.unshift( {
                id: '',
                orderNumber: '',
                trackingNumber: '',
                orderRemark: '',
                userRemark: '',
                customerId: this.formParam.customerId
            })
        },
        saveRecord(record){
            if(!record.orderNumber){
                this.$message.error('订单号不能为空')
                return false
            }
            this.$apiPost('lechun-cms/scrmOrder/save', {...record}).then(res => {
                this.$message.success('保存成功');
                this.initOrderList()
            })
        },
        deleteRecord(record,index){
            if(!record.id){
                this.orderList.splice(index,1)
            }else{
                this.$apiGet('lechun-cms/scrmOrder/delete', { id: record.id }).then(() => {
                    this.$message.success('删除成功')
                    this.orderList.splice(index,1)
                })
            }

        },
        getCookie(name){
            var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
            if (arr = document.cookie.match(reg))
                return unescape(arr[2]);
            else
                return null;
        },
        //复制文案
        copyText(text){
            console.log('te',text)
            var input = document.createElement("textarea"); // 创建input对象
            input.value = text; // 设置复制内容
            document.body.appendChild(input); // 添加临时实例
            input.select(); // 选择实例内容
            document.execCommand("Copy"); // 执行复制
            document.body.removeChild(input); // 删除临时实例
            this.$message({
                type: 'success',
                message: '已复制到剪贴板'
            });
        },
    }
}
</script>

<style lang="scss" rel="stylesheet/scss">
.customer-qw-wrap{
    background: #f2f2f2;
    height: 100%;
    overflow: auto;
    p{
        margin: 2px;
    }
    .el-tabs__item{
        font-size: 10px;
        padding: 0 8px;
    }
    .el-select-dropdown{
        left: 0!important;
    }
    .el-form-item__content {
        font-size: 12px;
    }

    .el-form-item__label {
        color: #795da3;
        font-size: 13px;
    }

    .el-form-item--mini.el-form-item {
        margin-bottom: 8px;
    }

    .el-input {
        width: 99%;
    }
    .el-descriptions__header{
        margin-bottom: 9px;
    }
    .el-tabs--border-card{
        background: #ffffff;
        box-shadow: none;
        border: none;
    }
    .el-descriptions-item__label.is-bordered-label{
        background: #ffffff;
        color: #000000;
    }
    .el-tabs--border-card > .el-tabs__content{
        padding: 10px;
        border-left:2px solid #f2f2f2;
        box-sizing: border-box;
    }

    .label-style{
        width: 85px;
    }
    .copy-text{
        white-space: pre-line;
        margin: 0;
        line-height: 18px;
        background: #f2f2f2;
        border: 1px solid #e8e8e8;
        border-radius: 5px;
        padding: 6px;
        max-height: 130px;
        overflow-y: scroll;
        scrollbar-width: none;
    }
    .el-descriptions--mini,.el-tag,.el-button--mini {
        font-size: 10px;
    }
    .el-input--mini {
        font-size: 10px;
    }
    .el-input--mini .el-input__inner {
        height: 24px;
        line-height: 24px;
    }
}

</style>